import {
  Box,
  Center,
  Flex,
  Link,
  Spinner,
  SpinnerProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import "../styles/dna.css";
import { Logo } from "./shared/Logo";

export const LibFullPageSpinner = () => {
  return (
    <Flex h="100vh">
      <Center w="full">
        <Spinner
          thickness="6px"
          size="xl"
          speed="0.65s"
          color={"primary.700"}
          emptyColor={"text.softest"}
        />
      </Center>
    </Flex>
  );
};

export const LibFullPageDNASpinner = () => {
  const [displayPhrase, setDisplayPhrase] = React.useState("");

  const phrases = React.useMemo(
    () => [
      "Retrieving your registry information...",
      "Loading data...",
      "Getting everything ready...",
      "Fetching data...",
      "Preparing your account...",
    ],
    []
  );

  React.useEffect(() => {
    setDisplayPhrase(phrases[Math.floor(Math.random() * phrases.length)]);
  }, [phrases]);

  return (
    <Flex
      h="100vh"
      w="100vw"
      bg="bg.main"
      align={"center"}
      justifyContent="center"
    >
      <Center py={12} px={24}>
        <Box>
          <Center mb={24}>
            <Text color="text" fontSize={"5xl"} textAlign="center">
              Welcome to Geneial
            </Text>
          </Center>

          <Center mb={20}>
            <LibBoxDNASpinner />
          </Center>

          <Center>
            <Text color="text.softer" maxW={"sm"}>
              {displayPhrase}
            </Text>
          </Center>
        </Box>
      </Center>
    </Flex>
  );
};

export const LibBoxDNASpinner = () => {
  return (
    <Center>
      <Box className={"loader"}>
        <Box
          className="dot dot1"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot2"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot3"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot4"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot5"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot6"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot7"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot8"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
        <Box
          className="dot dot9"
          _after={{ bg: "text.primary" }}
          _before={{ bg: "text.primary" }}
        >
          <Box as="i" bg="text.primary" opacity=".15"></Box>
        </Box>
      </Box>
    </Center>
  );
};

export const LibFullWidthSpinner = (props: SpinnerProps) => {
  const { size = "xl", thickness = "6px", ...rest } = props;

  return (
    <Flex>
      <Center h="full" w="full">
        <Spinner
          {...rest}
          size={size}
          thickness={thickness}
          speed="0.65s"
          color={"primary"}
          emptyColor={"text.softest"}
        />
      </Center>
    </Flex>
  );
};

export const AppFullFallbackComponent = ({
  error,
  resetComponent,
}: {
  error?: Error;
  resetComponent?: React.ReactNode;
}) => {
  return (
    <Box h="100vh" w="full">
      <Center h="full">
        <VStack
          borderWidth="1px"
          shadow={"md"}
          rounded="md"
          borderColor="border"
          p={8}
          spacing={8}
        >
          <VStack>
            <Center mb={8}>
              <Logo.Base h="12" />
            </Center>

            <Text fontSize="lg" color="danger">
              App Failed to Load
            </Text>

            <Text maxW={"sm"} textAlign="center" mt={8} color="text.soft">
              If you are seeing this, then we are sorry! Try a refresh and
              please send us a message if this persists.
            </Text>
          </VStack>
          <Box>
            {resetComponent ? (
              resetComponent
            ) : (
              <Link
                href="https://geneial.com/contact"
                fontSize="md"
                color="blue.700"
              >
                Contact us
              </Link>
            )}
          </Box>
        </VStack>
      </Center>
    </Box>
  );
};
